import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-promotion-settings-main',
		path: '/admin/promotion_settings',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_promotion_settings_main" */ './index'), {
			exportName: 'AdminPromotionSettingsMain',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
